/**
 * huongDanRules.js — LUẬT THUẦN cho "file hướng dẫn" của một màn hình (data_list_config.guideFile).
 *
 * Tài liệu hướng dẫn là file Markdown TĨNH máy chủ phục vụ ở `<server_url>/docs/<tên file>` (thư mục
 * `flexbiz-server-core/docs`, vd `so1-don-hang-guide.md`) — không cần đăng nhập, giống tài liệu mà
 * UserModuleManager và trình soạn Flow đang mở.
 *
 * KHÔNG import gì — test node chạy thẳng trên mã nguồn.
 */

/**
 * Tên file hướng dẫn -> URL đầy đủ. Trả '' khi không dùng được.
 *   "so1-don-hang-guide.md"      -> <server>/docs/so1-don-hang-guide.md
 *   "docs/so1-don-hang-guide.md" -> như trên (khỏi thành /docs/docs/…)
 *   "kho/nhap-kho.md"            -> <server>/docs/kho/nhap-kho.md (thư mục con)
 *   "/huong-dan/abc.md"          -> <server>/huong-dan/abc.md (đường dẫn tuyệt đối trên máy chủ)
 *   "https://…/abc.md"           -> giữ nguyên
 * Chặn `..` và `\` — tên file khai trong cấu hình không được trỏ ra ngoài thư mục tài liệu.
 */
function duongDanHuongDan(file, serverUrl) {
	if (typeof file !== 'string') return '';
	const f = file.trim();
	if (!f) return '';
	if (/^https?:\/\//i.test(f)) return f;
	if (f.indexOf('\\') >= 0 || f.split('/').some(seg => seg === '..')) return '';
	const base = String(serverUrl || '').replace(/\/+$/, '');
	const ma = (p) => p.split('/').filter(Boolean).map(encodeURIComponent).join('/');
	if (f.charAt(0) === '/') return base + '/' + ma(f);
	return base + '/docs/' + ma(f.replace(/^docs\//i, ''));
}

/** Tiêu đề hộp hướng dẫn. */
function tieuDeHuongDan(title) {
	const t = typeof title === 'string' ? title.trim() : '';
	return t ? `Hướng dẫn — ${t}` : 'Hướng dẫn sử dụng';
}

export { duongDanHuongDan, tieuDeHuongDan };
